import { useMemo } from "react";
import {
  Check,
  Circle,
  ClipboardList,
  Truck,
  Package,
  PackageOpen,
  MapPin,
  Send,
  Building2,
} from "lucide-react";
import { formatDateTime } from "@/lib/format";

const ICONS = {
  ACCEPTED: ClipboardList,
  DISPOSITION: Building2,
  PICKED_UP: Package,
  DISPATCHED: Send,
  UNLOADED: PackageOpen,
  ON_A_WAY_TO_CONSIGNEE: Truck,
  DELIVERED: MapPin,
};

export const StepperTimeline = ({ steps = [] }) => {
  const visibleSteps = useMemo(
    () => steps.filter((s) => s.status === "SUCCESS"),
    [steps],
  );
  if (!visibleSteps.length) return null;

  const lastIndex = visibleSteps.length - 1;
  const fullyDelivered =
    visibleSteps.length === steps.length &&
    visibleSteps[lastIndex].type === "DELIVERED";

  return (
    <ol
      className="divide-y divide-slate-100"
      data-testid="tracking-stepper"
    >
      {visibleSteps.map((step, i) => {
        const Icon = ICONS[step.type] || Circle;
        const isCurrent = !fullyDelivered && i === lastIndex;
        const state = isCurrent ? "active" : "completed";
        return (
          <li
            key={step.type}
            className={[
              "flex items-start gap-4 py-4",
              isCurrent
                ? "-mx-3 rounded-xl bg-indigo-50/70 px-3"
                : "",
            ].join(" ")}
            data-testid="tracking-timeline-step"
            data-state={state}
            data-type={step.type}
          >
            <div className="mt-1 shrink-0">
              {isCurrent ? (
                <span className="block h-6 w-6 rounded-full border-[3px] border-indigo-600 bg-white">
                  <span className="cb-pulse-dot block h-full w-full scale-50 rounded-full bg-indigo-600" />
                </span>
              ) : (
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-600">
                  <Check size={14} strokeWidth={3} className="text-white" />
                </span>
              )}
            </div>
            <div className="flex flex-1 items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <Icon size={16} strokeWidth={2} className="text-slate-400" />
                  <div className="text-base font-semibold text-slate-900">
                    {step.typeLabel || step.type}
                  </div>
                </div>
                <div className="mt-1 text-sm text-slate-500">
                  {step.originatedAt ? formatDateTime(step.originatedAt) : "—"}
                </div>
              </div>
              <div className="shrink-0 text-xs font-medium text-slate-400">
                {isCurrent ? "Aktuell" : `Schritt ${String(i + 1).padStart(2, "0")}`}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
};
